import { Plus } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const ADDONS = [
  { name: "Extra Operating Hours", note: "Extend beyond 8 hours per day" },
  { name: "Custom Car Livery", note: "In-game, in your branding" },
  { name: "Branded Registration & Leaderboard", note: "Digital package" },
  { name: "Lead Capture & CSV Export", note: "Post-event file" },
  { name: "Spectator Display", note: "Separate big screen for the crowd" },
  { name: "Physical Branded Panels", note: "Select rig panels, produced" },
  { name: "Full Custom Rig Wrap", note: "Full frame, produced & installed" },
  { name: "Additional Operator", note: "For high-traffic booths" },
  { name: "Second Compact Simulator", note: "Double your throughput" },
  { name: "Extra Event Day", note: "Extend Compact or Professional" },
  { name: "3DOF Motion Upgrade", note: "Add motion to 3-day Premium" },
  { name: "Two-Rig Head-to-Head", note: "Side-by-side racing battles" },
];

export const AddOns = () => (
  <section id="addons" className="relative py-20 lg:py-28 border-t border-line bg-panel/20" data-testid="addons-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        kicker="Customize Your Activation"
        title={
          <>
            Add-Ons <span className="text-electric">& Upgrades</span>
          </>
        }
        sub="Bolt-on extras to tailor any package to your booth, your brand, and your crowd."
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
        {ADDONS.map((a, i) => (
          <Reveal key={a.name} delay={(i % 4) * 0.06} y={20}>
            <div
              className="group h-full bg-panel border border-line p-5 hover:border-electric/50 transition-colors duration-300"
              data-testid={`addon-tile-${i}`}
            >
              <Plus className="h-4 w-4 text-electric mb-4 transition-transform duration-300 group-hover:rotate-90" strokeWidth={2} />
              <p className="font-display text-sm font-bold text-slate-100 uppercase tracking-wide leading-snug">
                {a.name}
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 mt-2.5">{a.note}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="text-center text-xs text-slate-500 mt-10 max-w-2xl mx-auto leading-relaxed" data-testid="addons-footnote">
          Every add-on is tailored and quoted alongside your package — tell us what you need in your
          quote request and we'll build it in.
        </p>
      </Reveal>
    </div>
  </section>
);
